import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { SharedModule } from 'app/shared';
import { filter, map } from 'rxjs';


@Component({
    selector: 'mini-splash',
    imports: [
        SharedModule,
    ],
    styles: [
        `
        .mini-splash {
            text-align: center;
            position: fixed;
            z-index: 34567;
            width: 100%;
            background: #ffffff;
            height: calc(100vh);
            display: none;
        }
        ap-logo {
            color: black;
            width: 65%;
            text-align: center;
            margin: 0 auto;
        }
        .website {
            position: fixed;
            bottom: 50px;
            left: 50%;
            transform: translateX(-50%);
        }
        @media (max-width: 330px) {
            .mini-splash {
                display: block;
            }
        }
        `,
    ],
    template: `
        <div class="mini-splash p-3" [class.d-none]="isSharedCma()">
            <ap-logo class="pt-4 pb-3"></ap-logo>
            <h2 class="pb-3">
                Looks like you’re on a mobile device
            </h2>
            <p>
                AUTOPROP is not optimized for small screens.
                We’re working on a mobile app. For now, please,
                switch to desktop or use a device with a bigger screen.
            </p>
            <a class="btn btn-primary website w-75" href="https://autoprop.ca/">
                <i class="fa fa-globe"></i>
                Back to AUTOPROP website
            </a>
        </div>
    `,
})
export class MiniSplashComponent {

    private router = inject(Router);

    private url = toSignal(
        this.router.events.pipe(
            filter(e => e instanceof NavigationStart || e instanceof NavigationEnd),
            map(e => e.url)
        ),
        { initialValue: this.router.url }
    );

    isSharedCma = computed(() => this.url().startsWith('/cma'));
}
